import { BoxGroupModel } from '../../models/PackagingRulesets';

// Extrae IDs de packaging desde distintos shapes del backend para evitar acoplar la UI.
export const getGroupPackagingItemIds = (group: BoxGroupModel | null | undefined): number[] => {
  if (!group) return [];

  const rawCandidates = [
    ...(Array.isArray((group as any).entry_lines) ? (group as any).entry_lines : []),
    ...(Array.isArray((group as any).entryLines) ? (group as any).entryLines : []),
    ...(Array.isArray((group as any).packaging_items) ? (group as any).packaging_items : []),
    ...(Array.isArray((group as any).packagings) ? (group as any).packagings : []),
    ...(Array.isArray((group as any).packagingItems) ? (group as any).packagingItems : []),
    ...(Array.isArray((group as any).items) ? (group as any).items : []),
    ...(Array.isArray((group as any).lines) ? (group as any).lines : []),
  ];

  const ids = rawCandidates
    .map((line: any) => {
      if (typeof line?.packaging_item_id === 'number') return line.packaging_item_id;
      if (typeof line?.packagingItemId === 'number') return line.packagingItemId;
      if (typeof line?.packaging_item?.id === 'number') return line.packaging_item.id;
      if (typeof line?.packagingItem?.id === 'number') return line.packagingItem.id;
      if (typeof line?.id === 'number') return line.id;
      return null;
    })
    .filter((id: number | null): id is number => typeof id === 'number' && id > 0);

  return Array.from(new Set(ids));
};
